/* ==========================================================================
   DC hero carousel — port of the vanilla JS in docs/design/top-page-mock/index.html
   Supports multiple instances ([data-dc-hero]) and the theme editor events.
   ========================================================================== */
(function () {
  'use strict';
  if (window.DCHero) { return; }

  var POSES = { '0': 'pos-0', '-1': 'pos-m1', '1': 'pos-p1', '-2': 'pos-m2', '2': 'pos-p2' };
  var POSE_CLASSES = ['pos-0', 'pos-m1', 'pos-p1', 'pos-m2', 'pos-p2'];

  function toArray(list) { return Array.prototype.slice.call(list || []); }

  function Hero(root) {
    this.root = root;
    this.slides = toArray(root.querySelectorAll('[data-dc-hero-slide]'));
    this.dots = toArray(root.querySelectorAll('[data-dc-hero-dot]'));
    this.counter = root.querySelector('[data-dc-hero-counter]');
    this.n = this.slides.length;
    this.idx = 0;
    this.timer = null;
    this.autoplay = root.getAttribute('data-autoplay') === 'true';
    this.interval = Math.max(1000, (parseFloat(root.getAttribute('data-interval')) || 5) * 1000);
    root.dcHero = this;
    this.bind();
    this.render();
    this.start();
  }

  Hero.prototype.render = function () {
    var n = this.n, idx = this.idx;
    this.slides.forEach(function (slide, i) {
      var rel = ((i - idx) % n + n) % n;
      if (rel > n / 2) { rel -= n; }
      var pose = POSES[String(rel)] || 'pos-p2';
      POSE_CLASSES.forEach(function (c) { slide.classList.remove(c); });
      slide.classList.add(pose);
      slide.classList.toggle('is-active', rel === 0);
      var pick = slide.querySelector('[data-dc-hero-pick]');
      if (pick) { pick.hidden = (rel === 0); }
    });
    this.dots.forEach(function (dot, i) {
      dot.setAttribute('aria-current', i === idx ? 'true' : 'false');
    });
    if (this.counter) { this.counter.textContent = (idx + 1) + ' / ' + n; }
  };

  Hero.prototype.start = function () {
    this.stop();
    if (!this.autoplay || this.n < 2) { return; }
    var self = this;
    this.timer = setInterval(function () { self.step(1); }, this.interval);
  };

  Hero.prototype.stop = function () {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  };

  Hero.prototype.step = function (d) {
    if (this.n < 1) { return; }
    this.idx = ((this.idx + d) % this.n + this.n) % this.n;
    this.render();
    this.start();
  };

  Hero.prototype.go = function (i) {
    if (this.n < 1) { return; }
    this.idx = ((i % this.n) + this.n) % this.n;
    this.render();
    this.start();
  };

  Hero.prototype.destroy = function () {
    this.stop();
    this.root.dcHero = null;
  };

  Hero.prototype.bind = function () {
    var self = this;
    var prev = this.root.querySelector('[data-dc-hero-prev]');
    var next = this.root.querySelector('[data-dc-hero-next]');
    if (prev) { prev.addEventListener('click', function () { self.step(-1); }); }
    if (next) { next.addEventListener('click', function () { self.step(1); }); }
    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { self.go(i); });
    });
    this.slides.forEach(function (slide, i) {
      var pick = slide.querySelector('[data-dc-hero-pick]');
      if (pick) { pick.addEventListener('click', function () { self.go(i); }); }
    });

    // horizontal swipe on touch devices
    var stage = this.root.querySelector('[data-dc-hero-stage]');
    if (stage) {
      var startX = null, startY = null;
      stage.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        startX = t.clientX; startY = t.clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) { return; }
        var t = e.changedTouches[0];
        var dx = t.clientX - startX, dy = t.clientY - startY;
        startX = startY = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { self.step(dx < 0 ? 1 : -1); }
      }, { passive: true });
    }
  };

  function init(scope) {
    toArray((scope || document).querySelectorAll('[data-dc-hero]')).forEach(function (el) {
      if (!el.dcHero) { new Hero(el); }
    });
  }

  function destroy(scope) {
    toArray((scope || document).querySelectorAll('[data-dc-hero]')).forEach(function (el) {
      if (el.dcHero) { el.dcHero.destroy(); }
    });
  }

  window.DCHero = { init: init, destroy: destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest ? e.target.closest('[data-dc-hero-slide]') : null;
    var root = slide ? slide.closest('[data-dc-hero]') : null;
    if (!root || !root.dcHero) { return; }
    var hero = root.dcHero;
    hero.idx = hero.slides.indexOf(slide);
    hero.render();
    hero.stop();
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target && e.target.closest ? e.target.closest('[data-dc-hero]') : null;
    if (root && root.dcHero) { root.dcHero.start(); }
  });
})();
